/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { parsePhoneNumber, getCountryCodeForRegionCode } from 'awesome-phonenumber'

@Injectable({
  providedIn: 'root',
})
export class PhoneNumberService {
  public getCountryCodeForRegionCode(country: string): string {
    const resolvedCountry = this.resolveSpecialMarket(country)
    return `+${getCountryCodeForRegionCode(resolvedCountry)}`
  }

  public getFormattedPhoneNumber(phoneNumber: string, country: string): string {
    const resolvedCountry = this.resolveSpecialMarket(country)
    if (!phoneNumber || !resolvedCountry) {
      return phoneNumber
    }

    return parsePhoneNumber(phoneNumber, { regionCode: resolvedCountry }).number?.international ?? phoneNumber
  }

  // This method transforms the country for special markets
  private resolveSpecialMarket(country: string): string {
    if (!!country && (country.toLowerCase() === 'xa' || country.toLowerCase() === 'xd')) {
      return 'ae'
    }
    return country
  }
}
